module.exports = __webpack_public_path__ + "static/media/Tattoo.da81799a.png";